import {
  createFeatureSelector,
  MemoizedSelector,
  createSelector
} from '@ngrx/store';
import { Location } from '@cpd-app/core-module/models';
import { HotSpotLocation } from '@cpd-app/generated';

import * as HotSpotsFeatureState from './hot-spots.state';

export const hotSpotStateSlice: MemoizedSelector<
  object,
  HotSpotsFeatureState.HotSpotsState
> = createFeatureSelector<HotSpotsFeatureState.HotSpotsState>(
  HotSpotsFeatureState.hotSpotsFeatureKey
);

export const locations: MemoizedSelector<object, Location[]> = createSelector(
  hotSpotStateSlice,
  (state) => {
    return state?.locations ?? [];
  }
);

export const occupationHotSpots: MemoizedSelector<object, HotSpotLocation[]> =
  createSelector(hotSpotStateSlice, (state) => {
    return state?.occupationHotSpots ?? [];
  });

export const occupationDemandInUserHomeArea: MemoizedSelector<
  object,
  HotSpotLocation[]
> = createSelector(hotSpotStateSlice, (state) => {
  return state?.occupationDemandInUserHomeArea ?? [];
});

export const occupationDemandbyArea: MemoizedSelector<
  object,
  HotSpotLocation[]
> = createSelector(hotSpotStateSlice, (state) => {
  return state?.occupationDemandbyArea ?? [];
});
